export class InvalidVizConfig extends Error {
  constructor(message: string, options?: ErrorOptions) {
    super(message, options);
    this.name = "InvalidVizConfig";
  }
}
